<template>
  <div
    v-if="activeLabels.length"
    ref="dots"
    class="conv-label-dots"
    @mouseenter="showPopover"
    @mouseleave="hidePopover"
  >
    <span
      v-for="label in visibleDots"
      :key="label.id"
      class="conv-label-dots__dot"
      :style="{ backgroundColor: label.color }"
    />
    <span v-if="hiddenCount" class="conv-label-dots__more">
      +{{ hiddenCount }}
    </span>

    <!-- Popover flutuante (position: fixed) — renderiza "fora" do card,
         sem ser cortado pelo overflow da lista; só informativo (pointer
         events desligados). O texto usa interpolação do Vue (sem XSS). -->
    <div
      v-if="popoverVisible"
      ref="popover"
      class="conv-label-popover"
      :style="popoverStyle"
    >
      <span
        v-for="label in activeLabels"
        :key="label.id"
        class="conv-label-popover__row"
      >
        <span
          class="conv-label-popover__dot"
          :style="{ backgroundColor: label.color }"
        />
        <span class="conv-label-popover__text">{{ label.title }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import conversationLabelMixin from 'dashboard/mixins/conversation/labelMixin';

// bolinhas fixas exibidas na lista; o excedente vira "+N"
const MAX_DOTS = 3;

export default {
  mixins: [conversationLabelMixin],
  props: {
    conversationId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      popoverVisible: false,
      popoverStyle: {},
    };
  },
  computed: {
    visibleDots() {
      // sempre no máximo 3 bolinhas fixas
      return this.activeLabels.slice(0, MAX_DOTS);
    },
    hiddenCount() {
      // quantos marcadores existem além das 3 bolinhas
      return Math.max(0, this.activeLabels.length - MAX_DOTS);
    },
  },
  beforeDestroy() {
    this.teardownListeners();
  },
  methods: {
    showPopover() {
      const el = this.$refs.dots;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      // posição inicial (medimos depois p/ decidir flip/clamp)
      this.popoverStyle = {
        position: 'fixed',
        top: `${rect.bottom + 6}px`,
        left: `${rect.left}px`,
        visibility: 'hidden',
      };
      this.popoverVisible = true;
      this.$nextTick(() => this.positionPopover(rect));
      window.addEventListener('scroll', this.hidePopover, true);
      window.addEventListener('resize', this.hidePopover);
    },
    positionPopover(rect) {
      const pop = this.$refs.popover;
      if (!pop) return;
      const pr = pop.getBoundingClientRect();
      const margin = 8;
      let top = rect.bottom + 6;
      let left = rect.left;
      // se estourar embaixo, abre pra cima
      if (top + pr.height > window.innerHeight - margin) {
        top = Math.max(margin, rect.top - pr.height - 6);
      }
      // não deixa vazar pela direita
      if (left + pr.width > window.innerWidth - margin) {
        left = Math.max(margin, window.innerWidth - pr.width - margin);
      }
      this.popoverStyle = {
        position: 'fixed',
        top: `${top}px`,
        left: `${left}px`,
      };
    },
    hidePopover() {
      this.popoverVisible = false;
      this.teardownListeners();
    },
    teardownListeners() {
      window.removeEventListener('scroll', this.hidePopover, true);
      window.removeEventListener('resize', this.hidePopover);
    },
  },
};
</script>

<style lang="scss" scoped>
.conv-label-dots {
  display: inline-flex;
  align-items: center;
  gap: var(--space-smaller);
  flex: none;
  cursor: default;
}

.conv-label-dots__dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex: none;
  box-shadow: 0 0 0 1px rgba(0, 33, 54, 0.08);
}

.conv-label-dots__more {
  font-size: var(--font-size-nano);
  font-weight: var(--font-weight-medium);
  color: var(--s-500);
  line-height: 1;
}

.conv-label-popover {
  z-index: 9999;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  gap: var(--space-smaller);
  max-width: 240px;
  max-height: calc(100vh - 16px);
  overflow: hidden;
  padding: var(--space-small);
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius-normal);
  box-shadow: var(--shadow-medium, 0 4px 16px rgba(0, 33, 54, 0.16));

  &__row {
    display: flex;
    align-items: center;
    gap: var(--space-smaller);
    min-width: 0;
  }

  &__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex: none;
  }

  &__text {
    font-size: var(--font-size-mini);
    line-height: 1.4;
    color: var(--s-800);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
